import { useId } from "react";

/** A unique id usable in SVG url(#...) references; useId's colons are invalid in those fragments. */
export const useSvgId = (prefix: string): string => `${prefix}-${useId().replace(/:/g, "")}`;
